require('./routes/route.js');
require('./routes/application.js');
require('./routes/loading.js');
require('./routes/preview.js');
require('./routes/router.js');
require('./routes/template.js');
